import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Home from './home/Home';
import Login from './login/Login';
import ApplyPage from './page/ApplyPage';
import DetailPage from './page/DetailPage';
import LicenseList from './license-list/license-list';
import Password from './login/Password';
import Notice from './notice/Notice';

// 보안 점검 기간 동안 모든 페이지에 안내 페이지를 노출한다. 점검 완료 후 false로 변경.
const MAINTENANCE_MODE = true;

function App() {
  if (MAINTENANCE_MODE) {
    return (
      <HashRouter>
        <Routes>
          <Route path="*" element={<Notice />} />
        </Routes>
      </HashRouter>
    )
  }

  return (
    <HashRouter>
        <Routes>
          <Route path="/login"  element={<Login />} />
          <Route path="/password"  element={<Password />} />
          <Route path="/license-list"  element={<LicenseList />} />
          <Route path="/apply-page"  element={<ApplyPage />} />
          <Route path="/detail-page"  element={<DetailPage />} />
          <Route path="*"  element={<Home />} />
        </Routes>
    </HashRouter>
  )
}

export default App
